/**
 * nodeSearch — tìm node theo TÊN và theo CÔNG DỤNG, không phân biệt hoa/thường và dấu tiếng Việt.
 *
 *   - "Tên": label hiển thị + mã kiểu node (type) + tên người dùng đặt cho node trên sơ đồ (data.name).
 *   - "Công dụng": description / inputDescription / outputDescription / category của định nghĩa node.
 *
 * Gõ "gui mail" vẫn ra "Gửi email"; gõ nhiều từ thì node phải chứa ĐỦ các từ (thứ tự tuỳ ý).
 * Điểm: khớp tên cao hơn khớp công dụng, khớp đầu chuỗi cao hơn khớp giữa chuỗi.
 */

export const chuanHoa = (s) => String(s == null ? '' : s)
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .replace(/đ/g, 'd').replace(/Đ/g, 'D')
  .toLowerCase().trim();

const thanhChu = (v) => (typeof v === 'string' ? v : (v == null ? '' : JSON.stringify(v)));

const tachTu = (q) => chuanHoa(q).split(/\s+/).filter(Boolean);

const escRe = (w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Từ khoá ngắn (1–2 ký tự, vd "ai", "fb") chỉ khớp ở ĐẦU một từ — nếu không "ai" sẽ khớp
 * cả "bài", "email"... và kết quả tìm vô nghĩa. Từ khoá dài hơn khớp ở bất kỳ đâu.
 */
const chua = (t, w) => (w.length <= 2 ? new RegExp(`(^|[^a-z0-9])${escRe(w)}`).test(t) : t.includes(w));

/** Chấm điểm 1 chuỗi cho danh sách từ khoá; 0 = không chứa đủ các từ. */
const diem = (text, tuKhoa, cauDayDu) => {
  const t = chuanHoa(text);
  if (!t) return 0;
  if (!tuKhoa.every((w) => chua(t, w))) return 0;
  if (t === cauDayDu) return 100;
  if (t.startsWith(cauDayDu)) return 80;
  if (t.includes(cauDayDu)) return 60;
  return 40;
};

/**
 * @param {object} def       định nghĩa node (label, type, description, ...)
 * @param {string} q         chuỗi tìm
 * @param {'all'|'name'|'usage'} cheDo
 * @param {string} [tenRieng] tên người dùng đặt cho node trên sơ đồ
 * @returns {{score:number, by:'name'|'usage'}|null}
 */
export const khopNode = (def, q, cheDo = 'all', tenRieng = '') => {
  const tuKhoa = tachTu(q);
  if (!tuKhoa.length) return { score: 1, by: 'name' };
  const cau = tuKhoa.join(' ');
  const d = def || {};

  let sTen = 0;
  if (cheDo !== 'usage') {
    sTen = Math.max(
      diem(tenRieng, tuKhoa, cau) + 10,
      diem(d.label, tuKhoa, cau) + 5,
      diem(d.type, tuKhoa, cau),
    );
    if (sTen <= 10) sTen = 0;
  }
  let sCongDung = 0;
  if (cheDo !== 'name') {
    // Gộp các trường mô tả thành một đoạn để "gửi tin nhắn zalo" khớp cả khi các từ nằm rải rác.
    const moTa = [d.description, d.inputDescription, thanhChu(d.outputDescription), d.category].join(' \n ');
    sCongDung = diem(moTa, tuKhoa, cau) * 0.5;
  }
  if (!sTen && !sCongDung) return null;
  return sTen >= sCongDung ? { score: sTen, by: 'name' } : { score: sCongDung, by: 'usage' };
};

/** Lọc + sắp xếp danh sách định nghĩa node (thanh kéo thả bên trái). */
export const timDinhNghiaNode = (defs, q, cheDo = 'all') => (defs || [])
  .map((def) => ({ def, m: khopNode(def, q, cheDo) }))
  .filter((x) => x.m)
  .sort((a, b) => b.m.score - a.m.score || String(a.def.label || '').localeCompare(String(b.def.label || ''), 'vi'))
  .map(({ def, m }) => ({ def, by: m.by, score: m.score }));
